var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLilith(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.35,573.17c-50.59-13.03-94.3-38.12-131.09-75.31-36.81-37.19-60.58-82.23-71.3-135.14-15.34-73.59-2.31-142.2,39.09-205.84,41.41-63.62,98.91-103.11,172.5-118.45,65.94-13.8,128.42-4.59,187.45,27.61-19.94-1.53-40.27,0-60.95,4.59-58.27,12.28-103.87,43.52-136.84,93.73s-43.33,104.64-31.06,163.3,43.52,104.27,93.73,136.84c50.22,32.59,104.84,42.75,163.88,30.47,19.94-3.83,38.72-10.72,56.34-20.69-40.62,53.67-93.91,87.41-159.84,101.19-19.17,3.84-38.72,5.75-58.66,5.75v165.61h152.95v63.25h-152.95v181.7h-63.25v-181.7h-154.09v-63.25h154.09v-173.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLilith);
export default __webpack_public_path__ + "static/media/Lilith.e884e16aa1893fccf620310388f1afb7.svg";
export { ForwardRef as ReactComponent };